












































































































































// vue
import { defineComponent, computed } from '@vue/composition-api';
import { useStore } from '@/store';

// configs
import links from '@/vue3/configs/navigationConfig';

// primevue
import Button from 'primevue/button';

export default defineComponent({
    components: {
        Button,
    },
    props: {
        isFullScreen: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any, vm) {
        // hooks
        const store = useStore();

        // properties
        const isDark = true;

        // computed
        const isMobile = computed(() => {
            return store.state.isMobile;
        });

        const isNavigationOpen = computed({
            get: () => {
                return store.state.isNavigationDrawerOpen;
            },
            set: (value: boolean) => {
                store.commit('setIsNavigationDrawerOpen', value);
            },
        });

        // methods
        const isCurrentRoute = (route: string) => {
            return vm.root.$route.fullPath === route;
        };

        const setIsNavigationOpen = (value: boolean) => {
            isNavigationOpen.value = value;
        };

        return {
            store,
            isMobile,
            isDark,
            isCurrentRoute,
            links,
            isNavigationOpen,
            setIsNavigationOpen,
        };
    },
});
